import { useContext, useEffect, useState } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { capitalizeFirstLetter } from "../../../../../utils/stringFunctions";
import { useNavigate } from "react-router-dom";
import { ContentState, getArtefactIcon } from "../../../../../models/SKArtifact";

interface AddDocumentProps {
  index: number;
  onClick: () => void;
  count?: number;
}
export const AddContentItem = ({ index, onClick, count = 0 }: AddDocumentProps) => {
  const { contentData, isEditable } = useContext(CreateArtifactContext);
  const [icon, setIcon] = useState<string | undefined>(undefined);
  const [imgSrc, setImgSrc] = useState<string>("/icons/Addsign.png");

  useEffect(() => {
    const icon = contentData.type ? getArtefactIcon(contentData.type) : undefined;
    if (count) {
      setImgSrc(isEditable ? "/icons/CheckItem.png" : "/icons/checkeditem.png");
    }
    setIcon(icon);
  }, [contentData.type, isEditable]);

  const showElement = () => {
    console.log("Add content Item Clicked");
    onClick();
  };

  return (
    <>
      <div className="relative w-full min-w-[200px]">
        <div className="flex items-center">
          <span>{index && <span className="content_count">{index}</span>}</span>

          <span className="content_title">Add Content</span>
        </div>
        <div
          className="add-content-frame"
          onClick={() => {
            showElement();
          }}
        >
          <div className="w-full h-full">
            <div className="flex flex-row flex-1 h-1/2">
              <div className="content-start w-full">
                {icon ? <img src={icon} alt="Back" className="inline w-[25px] h-[25px] mr-[10.22px]" /> : <></>}{" "}
                <span className="content-subtitle-text">{capitalizeFirstLetter(contentData.type ?? "")}</span>
              </div>
              <div className="flex content-start justify-end w-full">
                {count >= 0 ? (
                  <span className="inline-block ml-2 bg-white rounded-full input-plus-topic">
                    <img src={imgSrc} className="object-contain w-[19px] h-[20px] min-w-5" alt="Certification status" />
                  </span>
                ) : (
                  "+"
                )}
              </div>
            </div>
            <div className="thinseparator h-[1px]" />
            <div className="flex flex-row content-center flex-1 h-1/2">
              <div className={`content-end w-full ${count === 0 ? "text-gray-500" : "text-black"}`}>
                <span className="content-subtitle-note">
                  {count === 0 ? `Add ${capitalizeFirstLetter(contentData.type ?? "")}` : `${count} ${capitalizeFirstLetter(contentData.type ?? "")}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
